import Homepage from "./components";

export default Homepage;